import type { TO_NumberData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTONumberData: Omit<TO_NumberData, 'selectedVariable'> = {
  title: 'Default Number Title',
  viewType: 'Number',
  hasIcon: false,
  icon: 'Hash'
};
